import { Navigate, useParams } from '@tanstack/react-router';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';
import { useAccountAnalyticsBasicDetailsV2Query } from '@anytag/graphql';
import { AnalyticsSupportedSocialMediaType } from '@anytag/shared-types';
import { Template } from './template';

export const AnalyticsProfile = () => {
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const params = useParams({ from: '/_private-routes/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId' });

  const { data, loading } = useAccountAnalyticsBasicDetailsV2Query({
    skip: !params.brandAccountId,
    variables: { brandAccountId: Number(params.brandAccountId) },
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
      navigate({ to: '/' });
    }
  });

  if (!params.brandAccountId || !params.socialMediaAccountId || !params.socialMedia) {
    return <Navigate to="/analytics" />;
  }

  const brandAccount = data?.accountAnalyticsBasicDetailsV2;

  return (
    <div className="page-card">
      <RenderDataWithFallback loading={loading}>
        {/* We only continue when brandAccount valid */}
        {brandAccount ? (
          <Template
            brandAccount={brandAccount}
            socialMedia={params.socialMedia as AnalyticsSupportedSocialMediaType}
            socialMediaAccountId={Number(params.socialMediaAccountId)}
          />
        ) : null}
      </RenderDataWithFallback>
    </div>
  );
};
